import { type IntersectionCallbackType, type IntersectionSlugType } from '@/defs/observer'

import { getIntersectionConfig } from './getIntersectionConfig'

export const observeIntersection = (slug: IntersectionSlugType, el: Element, callback: IntersectionCallbackType) => {
  const config = getIntersectionConfig(slug)
  if (!config) return
  config.callbacks.set(el, callback)
  config.observer.observe(el)
}
